import { t } from '@lingui/core/macro';
import { SalesItemBookingCategoryType, SalesItemCategory } from '@navio/nsdk';

export const translateBookingCategories = (bookingCategoryFromApi: SalesItemBookingCategoryType | string): string => {
  switch (bookingCategoryFromApi) {
    case SalesItemBookingCategoryType.WHEEL_SERVICES:
      return t`Wheel services`;
    case SalesItemBookingCategoryType.WASH_SERVICES:
      return t`Wash services`;
    case SalesItemBookingCategoryType.STONE_CHIP_REPAIR:
      return t`Stone chip repair`;
    default:
      return t`Other`;
  }
};

/** Customer-facing name of a sales item category; nsdk's `SalesItemCategoryLabels` are English only. */
export const translateSalesItemCategory = (category: SalesItemCategory): string => {
  const labels: Record<SalesItemCategory, string> = {
    [SalesItemCategory.ADAPTER_FEE]: t`Adapter fee`,
    [SalesItemCategory.ADAPTER_PRODUCT]: t`Adapter product`,
    [SalesItemCategory.ADAPTER_SERVICE]: t`Adapter service`,
    [SalesItemCategory.CAR_REPAIR]: t`Car repair`,
    [SalesItemCategory.CAR_RIM]: t`Car rim`,
    [SalesItemCategory.CAR_TIRE]: t`Car tire`,
    [SalesItemCategory.CAR_WASH]: t`Car wash`,
    [SalesItemCategory.CAR_WINDSCREEN_REPAIR]: t`Windscreen repair`,
    [SalesItemCategory.CAR_WIPERS]: t`Car wipers`,
    [SalesItemCategory.FEE]: t`Fee`,
    [SalesItemCategory.MOUNTING]: t`Tire mounting`,
    [SalesItemCategory.MOUNTING_1_TIRE_PREPAID]: t`Mounting 1 tire prepaid`,
    [SalesItemCategory.MOUNTING_2_TIRES_PREPAID]: t`Mounting 2 tires prepaid`,
    [SalesItemCategory.MOUNTING_3_TIRES_PREPAID]: t`Mounting 3 tires prepaid`,
    [SalesItemCategory.MOUNTING_4_TIRES_PREPAID]: t`Mounting 4 tires prepaid`,
    [SalesItemCategory.RIM_BOLTS_REPAIR]: t`Rim bolts repair`,
    [SalesItemCategory.RIM_WASH]: t`Rim wash`,
    [SalesItemCategory.SHOP_RIM]: t`Rim sales`,
    [SalesItemCategory.SHOP_RIM_GENERIC_PREPAID]: t`Rim sale generic items prepaid`,
    [SalesItemCategory.SHOP_RIM_SALE_GENERIC]: t`Rim sale generic items`,
    [SalesItemCategory.SHOP_TIRE]: t`Tire sales`,
    [SalesItemCategory.SHOP_TIRE_GENERIC]: t`Tire sale generic items`,
    [SalesItemCategory.SHOP_TIRE_GENERIC_PREPAID]: t`Tire sale generic items prepaid`,
    [SalesItemCategory.WHEEL_CARRY]: t`Wheel carry`,
    [SalesItemCategory.WHEEL_CHANGE]: t`Wheel change`,
    [SalesItemCategory.WHEEL_STORAGE]: t`Wheel storage`,
    [SalesItemCategory.WHEEL_STORAGE_CANCEL_CUSTOMER_COLLECT]: t`Collect wheel set at facility`,
    [SalesItemCategory.WHEEL_STORAGE_CANCEL_WITHOUT_WHEEL_CHANGE]: t`Cancel wheel storage without wheel change`,
    [SalesItemCategory.WHEEL_STORAGE_CANCEL_WITH_WHEEL_CHANGE]: t`Cancel wheel storage with wheel change`,
    [SalesItemCategory.WHEEL_STORAGE_INBOUND_PICKUP]: t`Wheel storage inbound pickup`,
    [SalesItemCategory.WHEEL_STORAGE_NEW_CUSTOMER_DROP_OFF]: t`Drop off wheel set at facility`,
    [SalesItemCategory.WHEEL_STORAGE_NEW_FIRST_SEASON]: t`Tire hotel first season`,
    [SalesItemCategory.WHEEL_STORAGE_NEW_WITHOUT_WHEEL_CHANGE]: t`New wheel storage without wheel change`,
    [SalesItemCategory.WHEEL_STORAGE_NEW_WITH_WHEEL_CHANGE]: t`New wheel storage with wheel change`,
    [SalesItemCategory.WHEEL_STORAGE_PICKUP]: t`Wheel storage pickup`,
    [SalesItemCategory.WHEEL_STORAGE_PICKUP_AT_CUSTOMER_ADDRESS]: t`Wheel storage pickup at customer address`,
    [SalesItemCategory.WHEEL_STORAGE_PICKUP_AT_DIFFERENT_ADDRESS]: t`Wheel storage pickup at different address`,
    [SalesItemCategory.WHEEL_STORAGE_REHOME]: t`Wheel storage rehome`,
    [SalesItemCategory.WHEEL_STORAGE_RENEW]: t`Renew wheel storage`,
    [SalesItemCategory.WHEEL_STORAGE_SELF_PICKUP]: t`Wheel storage self pickup`
  };
  // A category newer than this build's nsdk arrives unmapped; show its code over nothing.
  return labels[category] ?? category;
};

export const translateServiceCategory = (name: string): string => {
  switch (name) {
    case 'Wheel change':
      return t`Wheel change`;
    case 'Wheel storage':
      return t`Wheel storage`;
    case 'Tire sale':
      return t`Tire sale`;
    case 'Car wash':
      return t`Car wash`;
    case 'Windscreen repair':
      return t`Windscreen repair`;
    default:
      return name;
  }
};
